import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import './DashboardSkeleton.css';

export function MemberDashboardSkeleton() {
  return (
    <div className="dashboard-layout">
      <Sidebar userRole="member" />
      <div className="dashboard-content">
        <Topbar userName="" userRole="member" />
        <div className="dashboard-main">
          <div className="dashboard-header skeleton-header">
            <div className="skeleton skeleton-title" />
            <div className="skeleton skeleton-btn" />
          </div>
          <div className="tasks-section skeleton-section">
            <div className="skeleton skeleton-section-title" />
            <div className="skeleton-table">
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function AdminDashboardSkeleton() {
  return (
    <div className="dashboard-layout">
      <Sidebar userRole="admin" />
      <div className="dashboard-content">
        <Topbar userName="Admin" userRole="admin" />
        <div className="dashboard-main">
          <div className="summary-cards skeleton-cards">
            <div className="skeleton skeleton-card" />
            <div className="skeleton skeleton-card" />
            <div className="skeleton skeleton-card" />
            <div className="skeleton skeleton-card" />
          </div>
          <div className="tasks-section skeleton-section">
            <div className="skeleton-header">
              <div className="skeleton skeleton-section-title" />
              <div className="skeleton skeleton-filters" />
            </div>
            <div className="skeleton-table">
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
              <div className="skeleton skeleton-row" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
